// MyWalletTransfer.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import './MyWallet.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faCheck, faClipboardCheck, faFileAlt } from '@fortawesome/free-solid-svg-icons';


const MyWalletTransferFromTemp = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const [userId, setUserId] = useState(authState.user._id);
  const [payerCode, setPayerCode] = useState(authState.user.think5whyscode);

  const [payerName, setPayerName] = useState(authState.user.name);
  const [payeeId, setPayeeId] = useState('');
  const [payeeCode, setPayeeCode] = useState('');
  const [payeeName, setPayeeName] = useState('');
  const [remarks, setRemarks] = useState('');
  const [amount, setAmount] =  useState(0);
  const [paymentClicked, setPaymentClicked] = useState(false);
  const [modePayment, setModePayment] = useState('Online');
  const [transactionId, setTransactionId] = useState('123456789');
  const [transactionDate, setTransactionDate] = useState(new Date());
  const [transactionStatus, setTransactionStatus] = useState('');
  const [paymentDetails, setPaymentDetails] = useState('');
  const [error, setError] = useState(null);
  const [walletBalanceAmount, setWalletBalanceAmount] = useState(0.00);
  const [walletBalancePoints, setWalletBalancePoints] = useState(0);
  const [walletLastUpdated, setWalletLastUpdated] = useState();
  const [walletLastUpdatedRemarks, setWalletLastUpdatedRemarks] = useState('');
  const [payeeCodeStatus, setPayeeCodeStatus] = useState(false);
  const [payeeCodeStatusMsg, setPayeeCodeStatusMsg] = useState('');
  const [payeeCodeButtonClicked, setPayeeCodeButtonClicked] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(false);
  
  const [doWalletTopup, setDoWalletTopup] = useState(false);

//WalletBalance
const fetchWalletBalance = useCallback(() => {
  const config = {
      url: "/walletbalance",
      method: "get",
      headers: { Authorization: authState.token }
  };

  fetchData(config, { showSuccessToast: false })
      .then(response => {
          // console.log("Wallet Balance Response:", response);
          if (response) {
              setWalletBalanceAmount(response.balanceAmount);
              setWalletBalancePoints(response.balancePoints);
              setWalletLastUpdated(response.lastTransactionDate);
              setWalletLastUpdatedRemarks(response.remarks);
          } else {
              console.error("Invalid response format: Wallet not found in response");
              setWalletBalanceAmount(0);
              setWalletBalancePoints(0);
              setWalletLastUpdated(null);
              setWalletLastUpdatedRemarks('');
          }
      })
      .catch(error => {
          console.error("Error fetching wallet master:", error);
          setWalletBalanceAmount(0);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchWalletBalance();
  }, [authState.isLoggedIn, fetchWalletBalance]);

  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    payeeCode: "",
    amount: "",
    remarks: ""
  });

  const handleChange = e => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  
  const payeeCodeValidationClicked = () => {
    // console.log("payeeCodeValidationClicked", formData);

    setPayeeCodeButtonClicked(true);
    
    // Validate Payee Code
    if (/^TU[a-zA-Z0-9]{12}$/.test(formData.payeeCode)) {
        // fetchPayeeCode(formData.payeeCode);
        // Validate Amount
        if (formData.amount <= 0 || !/^[0-9]+(\.[0-9]{1,2})?$/.test(formData.amount)) {
            setError("Error in Amount Input");
            return;
        }
        
        // Check Wallet Balance
        if (formData.amount > walletBalanceAmount) {
            setError("Your Wallet Balance has insufficient funds to make the transfer. Please recharge your Wallet.");
            setDoWalletTopup(true);
            return;
        }  

        if (formData.remarks=='') {
          setError("Transfer Remarks is required!!");
          return;
        }

        // Check for Self Transfer
        if (formData.payeeCode === payerCode) {
            setError(`Your Code is ${payerCode} and Payee Code is ${formData.payeeCode}. Self Transfer is not allowed!`);
            return;
          } 
          fetchPayeeCode(formData.payeeCode);
    } else {
        setError('Please enter a valid 14-character Think5Whys user code starting with TU.');
    }
};


const fetchPayeeCode = useCallback((payeeCode) => {
  // console.log("payeeCode for API call ", payeeCode);
  const config = {
      url: "/auth/verifyreferralcode",
      method: "post",
      headers: { Authorization: authState.token },
      data: { think5whyscode: payeeCode }
  };

  fetchData(config)
      .then(response => {
        // console.log("API Response: ", response); 
          if (response && response.status) {
              // console.log("fetchPayeeCode found ", response);
              setPayeeCodeStatus(true);
              setPayeeId(response.t5wcode._id);
              setPayeeName(response.t5wcode.name);
              setPayeeCodeStatusMsg("Payee Code found. 😊");
              // console.log("Payee Code found");
          } else {
              // console.log("Payee Code Not found");
              setPayeeCodeStatus(false);
              setPayeeCodeStatusMsg(`Payee Code ${payeeCode} not found! 😔 Make sure the Payee Code is valid.`);
          }
      })
      .catch(error => {
          // console.log("Payee Code Not found!", error);
          setPayeeCodeStatus(false);
          setPayeeCodeStatusMsg("Error in getting data");
      });
}, [fetchData, authState.token]);


useEffect(() => {
  if (!authState.isLoggedIn) return;
}, [authState.isLoggedIn, fetchPayeeCode]);

  const handleAddPayeeButtonClick = () => {
    setPaymentClicked(true);
    saveWalletTransaction();
  };

  const saveWalletTransaction = async () => {
    const requestData = {
      payerName: payerName,
      payerId: userId,
      payeeId: payeeId,
      dateTransaction: new Date(),
      particulars: "Wallet Transfer to "+payeeName+" by "+payerName,
      amount: formData.amount,
      currency: "Credits",
      inOut: 2,  //Transfer (Out)
      points: 0,
      wallet: "User Wallet",
      remarks: formData.remarks,
      modePayment: '"Think5Whys Wallet Transfer"',
      transactionId: 'D' + Date.now(),
      transactionDate: Date.now(),
      transactionStatus: 'Success',
      paymentDetails: 'NA',
      isActive: 1,
      isDeleted: 0,
      dateCreated: new Date(),
      createdBy: userId,
    };
    // console.log('Wallet Transfer data to be saved:', requestData);
    try {
      const config = { 
        url: `/wallet/transfer`, 
        method: "post", 
        data: requestData, 
        headers: { Authorization: authState.token } 
      };
      await fetchData(config);
      setPaymentStatus(true)
      // console.log("After Saving Data", fetchData)
      navigate('/wallet-mywallet');
    } catch (error) {
      console.error('An error occurred while fetching data:', error);
    }
  };

  const handleCancel = () => {
    navigate('/wallet-home');
  };

  return (
      <div className="p-6 bg-gray-900 [&_p]:text-gray50 text-white min-h-screen flex flex-col">
        <h2 className="text-3xl font-semibold mb-6 border-b border-gray-600 pb-2">Wallet Transfer</h2>

        <div className="flex-grow bg-gray-800 p-6 rounded-lg shadow-lg">
          <div className="mb-6 text-center">
            <p className="text-lg font-medium">Your Wallet Balance: <span className="text-green-400">Credits {walletBalanceAmount.toFixed(2)}</span></p>
          </div>

          <div className="mb-6 text-center">
            <p className="text-lg">Enter 14 Characters Alphanumeric Payee / Receiver ID (e.g., TU243AM5850150):</p>
          </div>

          <div className="mb-6 text-center">
            <p className="text-lg">Ask your Payee for their User Code from Home {'->'} Profile {'->'} My Think5Whys Code</p>
            <p className="text-gray-400">Your User Code / Think5Whys Code: <span className="text-yellow-300">{authState.user.think5whyscode}</span></p>
          </div>

          <div className="mb-6 flex flex-col gap-4">
            <div className="flex flex-col items-center">
              <input
                type="text"
                name="payeeCode"
                id="payeeCode"
                value={formData.payeeCode}
                placeholder="Input Payee Code"
                onChange={handleChange}
                className="w-full max-w-md h-12 px-4 text-center border border-gray-300 rounded-md bg-gray-700 text-white"
              />
              {fieldError("Payee Code")}
            </div>

            <div className="flex flex-col items-center">
              <input
                type="number"
                name="amount"
                id="amount"
                value={formData.amount}
                placeholder="Input Amount"
                onChange={handleChange}
                min="100"
                max="5000"
                className="w-full max-w-md h-12 px-4 text-center border border-gray-300 rounded-md bg-gray-700 text-white"
              />
              {fieldError("Amount")}
            </div>

            <div className="flex flex-col items-center">
              <input
                type="text"
                name="remarks"
                id="remarks"
                value={formData.remarks}
                placeholder="Input Remarks"
                onChange={handleChange}
                className="w-full max-w-md h-12 px-4 text-center border border-gray-300 rounded-md bg-gray-700 text-white"
              />
              {fieldError("Remarks")}
            </div>
          </div>

          <div className="flex flex-row justify-center mb-6">
            <button
              type="button"
              className="text-xs lg:text-sm w-fit bg-green-600 text-white px-6 py-2 rounded-lg shadow-md hover:bg-green-700 transition duration-300"
              onClick={payeeCodeValidationClicked}
              disabled={payeeCodeStatus}
            >
              {payeeCodeStatus ? "Payee Code Validated" : "Validate Payee Code"}
            </button>
            <button
              onClick={handleCancel}
              className="text-xs lg:text-sm w-fit bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
            >
              Cancel
            </button>
          </div>

          {error && (
            <div className="mb-6 text-center">
              <p className="text-red-500 text-xs lg:text-sm ">{error}</p>
            </div>
          )}
          

          <div className="text-center mb-6">
            <p className={payeeCodeStatus ? "text-green-400" : "text-red-400"}>
              <strong className="text-xs lg:text-sm ">{payeeCodeStatusMsg}</strong>
            </p>
          </div>

          { doWalletTopup && (
            <div className="mb-2 text-center flex flex-row">
              <button
                onClick={() => navigate("/wallet-topup")}
                className="text-xs lg:text-sm w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
              >
                Topup 
              </button>
            </div>
            )}
            
          {payeeCodeStatus && (
            <>
              <div className="mb-2 text-center">
                <p className="text-xs lg:text-sm ">Your Payee Name: <span className="text-yellow-300 text-lg">{payeeName}</span></p>
              </div>

              <div className="mb-2 text-center flex flex-row">
                <button
                  onClick={handleAddPayeeButtonClick}
                  disabled={paymentClicked}
                  className="text-xs lg:text-sm bg-orange-500 text-white px-6 py-2 rounded-lg shadow-md hover:bg-orange-600 transition duration-300"
                >
                  Confirm Transfer of {parseFloat(formData.amount).toFixed(2)} to {payeeName}
                </button>
                <button
                  onClick={handleCancel}
                  className="text-xs lg:text-sm w-fit bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
                >
                  Cancel
                </button>
              </div>

              {paymentClicked && (
                <div className="text-center">
                  {paymentStatus ? (
                    <p className="text-xs lg:text-sm text-green-500">Transferred Credits {parseFloat(formData.amount).toFixed(2)} to {payeeName}'s Wallet</p>
                  ) : (
                    <p className="text-xs lg:text-sm text-red-500">Transfer of Credits {parseFloat(formData.amount).toFixed(2)} to {payeeName} Failed. Please Retry.</p>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
  );
};

export default MyWalletTransferFromTemp;
